const Enums = {
    FACTORY: 'factory',
    QA: 'qa',
    DEFAULT: 'default',
    IT: 'it-officer',
    AI: 'aitechqa',
    AREA: 'area',
    GLOBAL: 'global',
    ADMIN:'admin'
  };
  
  export default Enums;
  